module.exports = __webpack_public_path__ + "img/pricematch.5dc6a4ff.jpg";